import { Carousel } from 'bootstrap';
document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.carousel');
    const carouselInstances = Array.from(carousels).map(carousel => new Carousel(carousel));
    carousels.forEach((carousel, index) => {
        carousel.addEventListener('mouseenter', () => {
            carouselInstances[index].pause();
        });
        carousel.addEventListener('mouseleave', () => {
            carouselInstances[index].cycle();
        });
    });
});
